
import Component from '../../../assets/scripts/modules/component'
// import merge from 'lodash/merge'

// ChartJS Docs: https://www.chartjs.org/docs/latest/

const DEFAULT_COLORS = [
  '#ff6000', '#0f00ff', '#ff928a', '#26d656', '#ffcb00', '#7f70c2', // 100% contrast
  '#ffa370', '#9876ff', '#fdb7b1', '#90ec9c', '#ffdf7e', '#a79ad4', // 50% contrast
  '#ffccae', '#c3b2ff', '#f8cfcb', '#c0f9c9', '#ffeeb6', '#cec7e6' // 25% contrast
]

class ArticleChartComponent extends Component {
  init () {
    this.chartContainer = this.element.querySelector('.article-chart__chart-container')
    this.dataContainer = this.element.querySelector('.article-chart__data-container')
    this.tableWrapper = this.element.querySelector('.article-chart__table-wrapper')
    this.canvas = this.element.querySelector('.article-chart__canvas')
    this.toggleLink = this.element.querySelector('.link--toggle')
    this.context = null
    this.chart = null
    this.data = null

    if (!this.chartContainer || !this.dataContainer || !this.canvas) {
      return
    }

    this.loadChart()

    if (this.toggleLink && this.tableWrapper) {
      this.initAccessibility()
    }
  }

  async loadChart () {
    const Chart = await import(/* webpackChunkName: "chart" */ 'chart.js/dist/Chart.bundle.js')

    Chart.defaults.global.defaultColor = 'rgba(0, 0, 0, .1)'
    Chart.defaults.global.defaultFontColor = '#170f3d'
    Chart.defaults.global.defaultFontFamily = '"Helvetica Neue", "Helvetica", "Arial", sans-serif'
    Chart.defaults.global.defaultFontSize = 13
    Chart.defaults.global.defaultFontStyle = 'bold'
    Chart.defaults.global.defaultLineHeight = 1.2
    Chart.defaults.global.animation.duration = 0
    Chart.defaults.global.aspectRatio = 1.5
    Chart.defaults.global.tooltips.mode = 'index'
    Chart.defaults.global.tooltips.intersect = false
    Chart.defaults.scale.ticks.beginAtZero = true

    console.log(Chart.defaults)

    this.initChart()
  }

  initChart () {
    this.context = this.canvas.getContext('2d')

    try {
      this.dataObject = window.JSON.parse(this.dataContainer.innerHTML)
    } catch (e) {
      console.warn(e)
      return
    }

    if (this.dataObject.data && this.dataObject.data.datasets) {
      // Old school for loop, yo 🤘
      for (let i = 0, j = this.dataObject.data.datasets.length; i < j; i++) {
        if (this.dataObject.type === 'pie') {
          this.dataObject.data.datasets[i].backgroundColor = []
          this.dataObject.data.datasets[i].borderColor = '#fff'

          for (let k = 0, l = this.dataObject.data.datasets[0].data.length; k < l; k++) {
            this.dataObject.data.datasets[i].backgroundColor[k] = DEFAULT_COLORS[k]
          }
        } else {
          this.dataObject.data.datasets[i].backgroundColor = DEFAULT_COLORS[i]
          this.dataObject.data.datasets[i].borderColor = DEFAULT_COLORS[i]

          if (this.dataObject.type === 'line' || (this.dataObject.data.datasets[i].type && this.dataObject.data.datasets[i].type === 'line')) {
            this.dataObject.data.datasets[i].fill = false
            this.dataObject.data.datasets[i].backgroundColor = '#fff'
          }
        }
      }
    }

    // console.log(this.dataObject, this.dataObject.options)

    // TODO: Webpack black magic going on here with the dynamic import
    this.chart = new Chart(this.context, this.dataObject) // eslint-disable-line no-undef
  }

  initAccessibility () {
    this.toggleLink.addEventListener('click', () => this.toggleTableWrapper())
  }

  toggleTableWrapper () {
    if (this.toggleLink.getAttribute('aria-expanded') === 'true') {
      this.toggleLink.setAttribute('aria-expanded', false)
      this.tableWrapper.setAttribute('aria-hidden', true)
    } else {
      this.toggleLink.setAttribute('aria-expanded', true)
      this.tableWrapper.setAttribute('aria-hidden', false)
    }
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.article-chart')) {
    element.instance = element.instance || new ArticleChartComponent(element)
  }
})
